<template>
  <el-container class='mars-ape-layout'>
    <el-main :class='`${$route.name}_main`'>
      <div style='display: flex; flex-direction: column' :class='`${$route.name}_main-inner`'>
        <router-view :class='`${$route.name}_main-inner__content`' />
      </div>
    </el-main>
  </el-container>
</template>
<script>

import { mapGetters } from 'vuex'

export default {
  name: 'PageLayout',
  data() {
    return {}
  },
  computed: {
    ...mapGetters(['userPermissions']),
    isRootRoutePath: function() {
      return this.$route.path === '/'
    }
  }
}
</script>
<style>
.mod-index {
  border-radius: 5px;
  background: #fff;
  padding: 20px;
  min-height: 800px;
  line-height: 1.5;
}

.mod-index p {
  margin: 0;
}

.mod-index h3 {
  margin-block-start: 0;
  margin-block-end: 0.5em;
}

.mod-index .xm-gt img {
  height: 240px;
  margin-left: -16px;
}

.mod-index .jx-zz img {
  height: 400px;
  margin-top: 24px;
  margin-right: 24px;
}

.el-container {
  background: #f0f2f5;
}

.el-aside {
  height: 100vh;
  position: sticky;
  top: 0;
  overflow-y: auto;
  overflow-x: hidden;
  box-shadow: 2px 0 6px rgba(0, 0, 0, 0.08);
  width: auto !important;
  z-index: 10;
  transition: all 0.3s;
  background: #fff;
}

.el-header {
  height: 64px !important;
  padding: 0;
  width: 100%;
}

.el-main {
  padding: 0;
  margin: 6px 4px;
  overflow: inherit;
  flex: none !important;
}

.main-page-content {
  border-radius: 5px;
  background: #ffffff;
}

.el-footer {
  height: auto !important;
}
</style>
<style lang='scss' scoped>
.fixed-header {
  position: fixed;
  top: 0;
  right: 0;
  z-index: 9;
  //width: calc(100% - #{$sideBarWidth});
  transition: width 0.28s;
}
</style>
